import { Eye, EyeSlash } from "@phosphor-icons/react";
import React, { useState } from "react";

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPasswrd, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPasswordShow, setOldPasswordShow] = useState(true);
  const [newPasswordShow, setNewPasswordShow] = useState(true);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(true);

  // const sendDetails = () => {};

  return (
    <div className="w-full h-full  lg:pt-36  lg:block lg:mt-0 mt-9">
      <div className="lg:w-[50%] lg:h-[50%] m-auto ">
        <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
          <p className="self-start">Change password</p>
        </nav>
        <div className="border border-gray-400 p-5 rounded-bl-md rounded-br-md ">
          <form action="" className="flex flex-col justify-between gap-6">
            <span className="flex flex-col">
              <label htmlFor="">Old password</label>

              <span className="w-full relative">
                {oldPasswordShow ? (
                  <EyeSlash
                    size={32}
                    className="cursor-pointer absolute top-2 right-5"
                    color="black"
                    onClick={() => setOldPasswordShow((curr) => !curr)}
                  />
                ) : (
                  <Eye
                    size={32}
                    className="cursor-pointer absolute top-2 right-5"
                    color="black"
                    onClick={() => setOldPasswordShow((curr) => !curr)}
                  />
                )}{" "}
                <input
                  type={oldPasswordShow ? "password" : "text"}
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black pr-14"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </span>
            </span>
            <span className="flex flex-col">
              <label htmlFor="">New password</label>
              <span className="w-full relative">
                {newPasswordShow ? (
                  <EyeSlash
                    size={32}
                    className="cursor-pointer absolute top-2 right-5"
                    color="black"
                    onClick={() => setNewPasswordShow((curr) => !curr)}
                  />
                ) : (
                  <Eye
                    size={32}
                    className="cursor-pointer absolute top-2 right-5"
                    color="black"
                    onClick={() => setNewPasswordShow((curr) => !curr)}
                  />
                )}
                <input
                  type={newPasswordShow ? "password" : "text"}
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black pr-14"
                  value={newPasswrd}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </span>
            </span>
            <span className="flex flex-col">
              <label htmlFor="">Confirm password</label>
              <span className="w-full relative">
                {confirmPasswordShow ? (
                  <EyeSlash
                    size={32}
                    className="cursor-pointer absolute top-2 right-5"
                    color="black"
                    onClick={() => setConfirmPasswordShow((curr) => !curr)}
                  />
                ) : (
                  <Eye
                    size={32}
                    className="cursor-pointer absolute top-2 right-5"
                    color="black"
                    onClick={() => setConfirmPasswordShow((curr) => !curr)}
                  />
                )}
                <input
                  type={confirmPasswordShow ? "password" : "text"}
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black pr-14"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </span>
            </span>
            <button className="bg-[#A7FF35] p-2 rounded-xl text-black w-full">
              Update
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
